export const formRules = [
  // {
  //   id: "1.1.A",
  //   rules: [
  //     {
  //       text: `APA Points will be calculated against Annual Average of Course Evaluation Score including all courses conducted (develop, deliver and evaluate) in the APA Cycle.`,
  //     },
  //     {
  //       text: `3.00-3.49=120, 3.5-3.99=140, 4.00-4.49=160, 4.50-4.89=180, 4.90-5.00=200 APA Points Max.`,
  //       evaluationOnly: true,
  //     }
  //   ],
  // },
  // {
  //   id: "1.1.B",
  //   rules: [
  //     {
  //       text: '',
  //     }
  //   ],
  // },
  {
    id: '1.1',
    rules: [
      // {
      //   text: `Faculty members who teach a full load of 12 credits per semester are automatically awarded 100 APA points. Faculty members who are underloaded (teaching less than 12 credits) are awarded 60 APA points. In both cases, the remaining points are determined by the faculty member's evaluation score.`
      // },
      {
        text:"Faculty members who teach a full load of 12 credits per semester are automatically awarded 125 APA points. Faculty members who are underload (teaching less than 12 credits) are awarded 62.5 APA points. In both cases, the remaining points are determined by the faculty member's evaluation score."
      },
      // {
      //   text: `Each band corresponds to a maximum point allocation:
      //   3.00-3.49=60, 3.5-3.99=70, 4.00-4.49=80, 4.50-4.89=90, 4.90-5.00=100 APA Points Max`,
      //   evaluationOnly: true,
      // },
      {
        text: `Total APA Points = 125 (Credit-based) + Final APA Points from Evaluation`
      }
    ]
  },
  {
    id: '1.2',
    rules: [
      {
        text: `APA Points will be calculated against successful completion of following activities. Maximum APA point is 100.`
      }
    ]
  },
  {
    id: '1.3',
    rules: [
      {
        text: `5 APA Points/ Advising Session rostered the department/school.`
      },
      {
        text: `Tutorial, Extra Class, Student Advising, it should be provided by department/department approval required.`
      },
      {
        text: `Per sessions minimum 1 hour, max 100 APA Points.`
      },
      {
        text: 'Maintaining regular office hour.'
      }
    ]
  },
  {
    id: '2.1',
    rules: [
      {
        text: `APA points will be calculated against published research outcomes in the APA Cycle.`
      },
      {
        text: `Points vary as per the category and venue of publishing as specified in first right column. Max APA point is 200.`
      },
      {
        text: `As a co-author of a published work, an IUB faculty *principal author* will receive *80%* of the allocated APA points, while an IUB faculty *co-author (normal author)* will receive *50%* of the allocated APA points. If a publication involves more than one IUB faculty member, the allocated APA points will be distributed among them according to their mutual agreement.`
      },
      {
        text: `NO_BULLET:<b>Special Instruction for SBE,SOL and SLASS:</b>`
      },
      {
        text: `<b>Journal Article/s:</b> 40% additional APA points for SBE,SOL and SLASS faculty members`
      },
      {
        text: `<b>Book Chapter/s:</b> 30% additional APA points for SBE,SOL and SLASS faculty members`
      }
    ]
  },
  {
    id: '2.2',
    rules: [
      {
        text: `NO_BULLET:<b>Grant Submit:</b>`
      },
      {
        text: `20 APA points for the lead applicant of an International grant proposal submission and 10 APA points for each of the team members.`
      },
      {
        text: `10 APA points for the lead applicant of a National/IUB grant proposal submission and 5 APA points for each of the team members.`
      },
      {
        text: `NO_BULLET:<b>Grant Success: [Lead Applicant/ Member]</b>`
      },
      {
        text: `IUB Grant (20/10 APA points), National Grant (20/10 APA points) International (50/20 APA points).`
      },
      {
        text: `Max. APA points is 100.`
      }
    ]
  },
  {
    id: '2.3',
    rules: [
      {
        text: `Research projects funded by any industry actor or stake holders.`
      },
      {
        text: `Total 20 APA points for each Completed Project and additional 2 APA points for per IUB RA Involved in the project.`
      },
      {
        text: `Total APA points will be shared among the Faculty Member/s involved. Max. APA point is 50.`
      }
    ]
  },
  {
    id: '2.4',
    rules: [
      {
        text: `Presenting/attending in research and training events will carry 30 APA points max.`
      }
    ]
  },
  {
    id: '2.5',
    rules: [
      {
        text: `Presenting/attending in research and training events will carry 30 APA points max.`
      }
    ]
  },
  {
    id: '3.1',
    rules: [
      {
        text: `Max. 200 APA points are allocated for performing following academic roles and services:`
      }
    ]
  },
  {
    id: '3.2',
    rules: [
      {
        text: `Max. 200 APA points are allocated for performing following co- and extracurricular roles and services:`
      }
    ]
  }
];
